'use client'

import type { HTMLRendererProps } from '@src/components/HTMLRenderer/HTMLRenderer.props'
import ShadowRoot from '@src/utils/ShadowRoot'

export const HTMLRenderer = (props: HTMLRendererProps) => {
  const { srcDoc = '' } = props

  return (
    <ShadowRoot>
      <div dangerouslySetInnerHTML={{ __html: srcDoc }}></div>
    </ShadowRoot>
  )
}
